import { Box } from "@mui/material";
import { useTu } from "@src/appV2/i18n/useTu";

import { Icon } from "../../../components/Icon";
import { Text } from "../../../components/Text";

interface NavScrollPillProps {
  direction: "up" | "down";
  count: number;
  onClick: () => void;
}

export function NavScrollPill(props: NavScrollPillProps) {
  const { direction, count, onClick } = props;
  const { tu } = useTu("navigation");

  return (
    <Box
      component="button"
      type="button"
      aria-label={
        direction === "down"
          ? tu("Scroll to pending items below")
          : tu("Scroll to pending items above")
      }
      onClick={onClick}
      sx={(theme) => ({
        position: "absolute",
        ...(direction === "down" ? { bottom: 16 } : { top: 16 }),
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        gap: 2,
        paddingX: 4,
        paddingY: 3,
        borderRadius: "999px",
        border: "none",
        cursor: "pointer",
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText,
        boxShadow: theme.shadows[4],
        whiteSpace: "nowrap",
        transition: theme.transitions.create(["background-color"], {
          duration: theme.transitions.duration.short,
        }),
        "&:hover": {
          backgroundColor: theme.palette.error.dark,
        },
      })}
    >
      {direction === "up" && <Icon type="chevron-up" size="small" sx={{ color: "inherit" }} />}
      <Text variant="caption" sx={{ color: "inherit", fontWeight: "bold", lineHeight: 1 }}>
        {count}
      </Text>
      {direction === "down" && <Icon type="chevron-down" size="small" sx={{ color: "inherit" }} />}
    </Box>
  );
}
